import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
}
export const CHECKOUT_URL = 'https://estetica-digital-pro.impultienda.ar/checkout';
export function CTAButton({
  label = 'QUIERO PROFESIONALIZAR MI INSTAGRAM',
  className = '',
  href = CHECKOUT_URL
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  return <a href={href} onClick={handleClick} className={cn('group inline-flex min-h-[52px] w-full max-w-sm items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#4656f5] via-[#8a55df] to-[#ff7396] px-5 py-3.5 text-center text-[0.78rem] font-bold uppercase leading-tight tracking-wide text-white shadow-lg shadow-indigo-500/25 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:brightness-105 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300/50 sm:text-sm', className)} data-id="element-41" data-mp="33ppalc7e1uk6">
      {label}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden data-id="element-42" data-mp="1i9kwbxflx6eb" />
    </a>;
}